import { render } from "./LoginPleaseSalon.vue?vue&type=template&id=34d83f02"
import script from "./LoginPleaseSalon.vue?vue&type=script&lang=js"
export * from "./LoginPleaseSalon.vue?vue&type=script&lang=js"

import "./LoginPleaseSalon.vue?vue&type=style&index=0&id=34d83f02&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__